var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.answerContainerClass},[_c('span',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]),_c('span',{class:_vm.answerClass},[_vm._v(_vm._s(_vm.answer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }